import React from 'react';
import { useNavigate } from 'react-router-dom';
import useNotifications from '../lib/useNotifications';
import { fmtLocal } from '../lib/dates';
import logo from '../assets/chitconnect-logo-blue.png';
import { getNotificationHref } from '../lib/notificationLinks';

function lineClampStyle(lines = 2) {
  return {
    display: '-webkit-box',
    WebkitLineClamp: lines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  };
}

export default function Notifications() {
  const navigate = useNavigate();
  const {
    list,
    unread,
    loading,
    error,
    refresh,
    markAllRead,
    markRead,
  } = useNotifications();

  const openNotification = (n) => {
    try {
      if (!n?.read_at) markRead?.(n.id);
    } catch {}
    const href = getNotificationHref(n);
    if (/^https?:\/\//i.test(href)) window.location.href = href;
    else navigate(href);
  };

  return (
    <div className="main-content">
      <div className="page">
        {/* Logo header (match Bank template) */}
        <div className="login-logo-container" style={{ justifyContent: 'center' }}>
          <img className="login-logo" src={logo} alt="ChitConnect" />
        </div>

        <div className="card" style={{ padding: 20, borderRadius: 16 }}>
          <div className="notif-header">
            <div>
              <h2 style={{ margin: 0 }}>Notifications</h2>
              <div style={{ color: '#6b7280', marginTop: 6 }}>
                {unread > 0 ? `${unread} unread` : 'All caught up'}
              </div>
            </div>
            <div className="notif-actions">
              <button className="btn" onClick={refresh} disabled={loading}>
                Refresh
              </button>
              <button className="btn" onClick={markAllRead} disabled={loading || unread <= 0}>
                Mark all read
              </button>
            </div>
          </div>
        </div>

        {error && (
          <div className="card" style={{ marginTop: 16, padding: 16, borderRadius: 16, border: '1px solid #fecaca' }}>
            <div style={{ fontWeight: 700, color: '#b91c1c' }}>Error</div>
            <div style={{ marginTop: 6 }}>{error}</div>
          </div>
        )}

        {loading && (
          <div className="card" style={{ marginTop: 16, padding: 16, borderRadius: 16 }}>
            Loading…
          </div>
        )}

        {!loading && (!list || list.length === 0) && (
          <div className="card" style={{ marginTop: 16, padding: 16, borderRadius: 16 }}>
            No notifications.
          </div>
        )}

        {!loading && list && list.length > 0 && (
          <div className="card" style={{ marginTop: 16, padding: 0, borderRadius: 16, overflow: 'hidden' }}>
            {list.map((n) => (
              <div
                key={n.id}
                style={{
                  padding: 16,
                  borderBottom: '1px solid #e5e7eb',
                  cursor: 'pointer',
                }}
                onClick={() => openNotification(n)}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 800, fontSize: 18, ...lineClampStyle(2) }}>{n.title}</div>
                    {n.body && (
                      <div style={{ marginTop: 8, color: '#374151', ...lineClampStyle(3) }}>{n.body}</div>
                    )}
                    {n.type && <div style={{ marginTop: 10, color: '#6b7280', fontSize: 12 }}>Type: {n.type}</div>}
                  </div>
                  <div style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>{fmtLocal(n.created_at)}</div>
                    <div style={{ marginTop: 10, fontSize: 12, color: n.read_at ? '#6b7280' : '#111827' }}>
                      {n.read_at ? 'Read' : 'Unread'}
                    </div>
                    <button
                      className="link-button"
                      style={{ marginTop: 8 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        openNotification(n);
                      }}
                      title="Open"
                    >
                      Open
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
